class Zone {
  constructor(title, cityId) {
    this.title = title;
    this.cityId = cityId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      zoneId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      modalIcon: '',
      zoneManagmentInformationTableHeaders: [
        { text: 'ردیف', value: 'counter', align: 'center' },
        { text: 'شهرستان', value: 'city', align: 'center' },
        { text: 'عنوان', value: 'title', align: 'center' },
        { text: 'عنوان نمایشی', value: 'displayName', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن ناحیه';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش ناحیه';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getZoneFunction(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.zone = new Zone('', null);
      this.showAddEditModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addZoneFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش ناحیه';
        this.$refs.confirm.text = 'از ویرایش ناحیه اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف ناحیه';
        this.$refs.confirm.text = 'از حذف ناحیه اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addZoneFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editZoneFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteZoneFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.zoneId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
  },
};
